import { Controller } from '@hotwired/stimulus'
import { hideElement, showElement } from 'utils/toggle_element_visibility'

export default class extends Controller {
  static targets = ["searchInput", "item", "searchString", "toggleInput", "toggleValue"]

  filterItems() {
    const searchStrings = this.searchStringTargets
    const searchInput = this.searchInputTarget.value.toUpperCase()

    this.itemTargets.forEach((item) => {
      const titleElement = searchStrings.find((searchString) => item.contains(searchString))
      const title = titleElement.innerText.toUpperCase()

      if (title.indexOf(searchInput) === -1) {
        hideElement(item)
      } else {
        showElement(item)
      }
    })
  }

  filterItemsWithToggle() {
    const isToggleSelected = this.toggleInputTarget.checked
    const selectedValue = this.toggleInputTarget.value.toUpperCase()
    const toggleValues = this.toggleValueTargets
    const searchStrings = this.searchStringTargets
    const searchInput = this.searchInputTarget.value.toUpperCase()

    this.itemTargets.forEach((item) => {
      const valueElement = toggleValues.find((toggleValue) => item.contains(toggleValue))
      const value = valueElement.innerText.toUpperCase()
      const titleElement = searchStrings.find((searchString) => item.contains(searchString))
      const title = titleElement.innerText.toUpperCase()
      const toggleMatch = isToggleSelected && selectedValue === value || !isToggleSelected
      const filterMatch = title.indexOf(searchInput) !== -1

      if (toggleMatch && filterMatch) {
        showElement(item)
      } else {
        hideElement(item)
      }
    })
  }
}
